"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EditorConfigContext", {
  enumerable: true,
  get: function get() {
    return _context["default"];
  }
});
Object.defineProperty(exports, "EditorConfigProvider", {
  enumerable: true,
  get: function get() {
    return _context.EditorConfigProvider;
  }
});
exports["default"] = void 0;
exports.isObject = isObject;
exports.merge = merge;
Object.defineProperty(exports, "useEditorConfig", {
  enumerable: true,
  get: function get() {
    return _context.useEditorConfig;
  }
});

var _context = _interopRequireWildcard(require("./context"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
} // import { embeddables } from '@peracto/peracto-legacy-blocks'


function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}

function merge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));
        merge(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    }
  }

  return merge.apply(void 0, [target].concat(sources));
}

var Config = /*#__PURE__*/function () {
  function Config(plugins, config) {
    _classCallCheck(this, Config);

    var defaultPluginConfig = plugins.content.map(function (plugin) {
      var config = {};

      if (plugin.hasOwnProperty('configKey')) {
        config[plugin.configKey] = plugin.config;
      }

      return config;
    }).reduce(function (carry, componentConfig) {
      return Object.assign(carry, componentConfig);
    }, {});
    this.config = merge({}, {
      /* embeddables */
    }, {}, {
      plugin: defaultPluginConfig
    }, config);
  }

  _createClass(Config, [{
    key: "all",
    value: function all() {
      return this.config;
    }
  }, {
    key: "get",
    value: function get(propertyPath) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return propertyPath.split('.').reduce(function (prev, curr) {
        return prev ? prev[curr] : undefined;
      }, this.config) || def;
    }
  }]);

  return Config;
}();

var _default = Config;
exports["default"] = _default;